import TopMedia from './TopDLMM'

export default TopMedia
